import {Autocomplete, TextField, Box} from '@mui/material';
import {currencies} from 'constants/currencies';

const CurrencySelector = ({onChange, value}) => {
  return (
    <Autocomplete
      options={currencies}
      getOptionLabel={option =>
        `${option.code} - ${option.name} (${option.country})`
      }
      value={currencies.find(c => c.code === value) || null}
      isOptionEqualToValue={(option, val) => option.code === val?.code}
      filterOptions={(options, {inputValue}) =>
        options.filter(
          option =>
            option.code.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.country.toLowerCase().includes(inputValue.toLowerCase()),
        )
      }
      onChange={(event, newValue) => onChange(newValue ? newValue.code : null)}
      renderOption={(props, option) => {
        const {key, ...optionProps} = props;
        return (
          <Box
            key={key}
            component="li"
            sx={{'& > img': {mr: 2, flexShrink: 0}}}
            {...optionProps}>
            <img
              loading="lazy"
              width="20"
              src={option.flag}
              alt={option.country}
            />
            {option.code} - {option.name} ({option.country})
          </Box>
        );
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Select Currency"
          placeholder="Search currency by code, name, or country"
        />
      )}
    />
  );
};

export default CurrencySelector;
